import LocalizedStrings from "react-localization";

const Strings = new LocalizedStrings({
  "en-US": {
    //Login
    of: "of",
    login: "Login",
    logout: "Logout",
    loading: "Loading",
    profile: "Profile",
    signInToYourAccount: "Sign In to your account",
    forgotPassword: "Forgot password?",
    signUp: "Sign up",
    registerNow: "Register Now!",
    password: "Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    confirmPassword: "Confirm Password",
    passwordProp: "password",
    confirmPasswordProp: "confirmPassword",
    remember: "Remember me",
    enter: "Enter",
    upload: "Upload",
    filesSupported: "Files supported: JPEG, PNG",
    upto: "upto",
    //warehouse
    toolCategories: "Asset Categories",
    toolcategory: "Asset category",
    deletedTools: "Deleted Assets",
    deletionRequest: "Deletion Request",
    deletionRequests: "Deletion Requests",
    cancelDeletionRequest: "Cancel deletion request",
    acceptDeletionRequest: "Accept deletion request",
    editDeletionRequest: "Edit deletion request",
    totalTools: "Total Assets",
    damagedAssetReportTitle: "Damaged Asset Report",
    tochangeAssetTo: "To change asset status to",
    damaged: "Damaged",
    pleaseProvideDetailsOfTheDamage: "please provide details of the damage.",
    photosOfDamagedAsset: "Photos of Damaged Asset",
    enterDetails: "Enter details",
    damagedAssetReportSelectFileAlt: "Select file",
    damagedAssetReportAssetAlt: "Asset",
    damagedAssetReportRemovePhoto: "Remove photo",
    damagedAssetReportSuccessMessage:
      "Your asset report has been successfully logged.",
    filter: "Filter",
    deletedCategory: "Delete Category",
    cancelRequest: "Cancel request",
    deletionDetailCancelRequestMessage:
      "Do you want to cancel this deletion request?",
    deletionDetailRemoveToolsMessage:
      "Do you want to remove these tools from this deletion request?",
    deletionDetailToolsRemovedSuccess:
      "Selected tools have been removed successfully.",
    deletionDetailRequestCancelledSuccess:
      "Deletion request cancelled successfully.",
    export: "Export",
    add: "Add",
    inCart: "In cart",
    noCategory: "No categories selected",
    selectAtleastone: "Please Select At Least One Category ",
    cancel: "Cancel",
    categorySelected: "categories selected",
    sureMsg: "Are you sure you want to delete these categories ",
    removetools: "Remove assets",
    confirm: "Confirm",
    request: "Request",
    requestNo: "Request No",
    requestedBy: "Requested by",
    noOfItems: "No. of Assets",
    requestedOn: "Requested On",
    available: "Avl",
    close: "Close",
    // Tool Shed
    selectQuantity: "Select Quantity",
    tenPlus: "10 +",
    enterOnerOrmore: "Please enter one or more quantity",
    numberonly: "Enter Numbers only",
    quantityAlert: "Requested quantity is not available",
    yes: "Yes",
    no: "No",
    to: "to",
    // message center
    yesterday: "Yesterday",
    today: "Today",
    proceed: "Proceed",
    notifications: {
      assetDeletionRequestedPrefix:
        "requested asset Deletion request under deletion Ref :",
      missingDeletionRef: "N/A",
    },

    // add Tools
    //placeholders
    toolCategory: "Asset category",
    timestamp: "Timestamp",
    brandName: "Brand",
    toolCategoryName: "Asset category name",
    serialNumber: "Serial Number",
    brand: "Model Type",
    nfcScanCode: "NFC scan code",
    qrScanCode: "QR Scan Code",
    status: "Status",
    mobileNo: "Mobile no.",
    modelNo: "Model No",
    details: "Details",
    validate: "Validate",
    //Propname
    toolOrgProp: "toolOrg",
    toolCategoryProp: "toolCategory",
    serialNumberProp: "serialNumber",
    brandProp: "brand",
    nfcScanCodeProp: "nfcScanCode",
    qrScanCodeProp: "qrScanCode",
    barCodeProp: "barCode",
    statusProp: "status",
    mobileNoProp: "mobileNo",
    countryNameProp: "countryName",
    modelNoProp: "modelNo",
    toolImage: "Asset image",
    editCategory: "Edit category",
    deleteTools: "Delete assets",
    editTools: "Edit assets",
    changeStatus: "Change status",
    addTool: "Add asset",
    toolAlertSureMsg: "Are you sure you want to delete these asset ",
    toolAlertEditMsg: "Are you sure you want to edit these asset ",
    toolAlertChangeMsg:
      "Are you sure you want to change the status of these asset ",
    notool: "No Assets Selected",
    selectAtleastoneTool: "Please Select At Least One Asset ",
    toolSelected: "Assets Selected",
    assetStatus: {
      available: "Available",
      outForService: "Out for service",
      damaged: "Damaged",
      lost: "Lost",
      stolen: "Stolen",
      booked: "Booked",
      checkedOut: "Checked out",
      pending: "Pending",
      reserved: "Reserved",
      deleted: "Deleted",
      cancelled: "Cancelled",
      returnValidationPending: "Returned - Validation Pending",
      transferInProgress: "Transfer in Progress",
      deletionRequested: "Del. requested",
      transferred: "Transferred",
      returned: "Returned",
    },
    //delete tool
    reasonForDeletion: "Reason for Deletion",
    deletionNo: "Deletion No",
    deletionReff: "Deletion Ref",
    reason: "Reason",
    errors: {
      noSpace: "No Space Allowed",
      requiredField: "This field is required.",
      numericOnly: "Only Numeric values are allowed",
      alphaNumeric:
        "Please enter valid string without extra space and special characters ",
      specialCharacterNotAllowed: "Special characters not allowed",
      validEmailError: "Enter a valid email.",
      onlyAlphabatesAlowed: "Only contain alphabetical characters.",
      Max_Limit: "Please enter minimum six/6 characters",
      search_Limit: "Please enter minimum three/3 characters",
      MatchPass: "New Password and Repeat Password does not match",
      passwordStrength:
        "Password must be at least 8 characters with uppercase, lowercase, and a number", // NO SONAR
      currentPasswordIncorrect: "Current password is incorrect", // NO SONAR
      enterValidMobileno: "Enter a valid mobile Number",
      validEmailMobileError: "Enter a valid email or mobile number.",
    },

    //WAREHOUSE
    inventory: "Inventory",
    deletionRef: "Deletion Reference",
    deleteCategory: "Delete category",
    deleteCategories: "Delete categories",

    // Devices
    unlink: "Unlink",
    retire: "Retire",
    updateLocation: "Update Location",
    transplant: "Transplant",

    //Booking
    checkouts: "Checkouts",
    reserved: "Reserved",
    reservation: "Reservations",
    reservationNo: "Reservation No",
    validTill: "Valid till",
    reservationOn: "Reservation on",
    reservedBy: "Reserved by",
    reservedOn: "Reserved on",
    extentionRequest: "Extention requests",
    extendedTo: "Extended to",

    requests: "Requests",
    returns: "Returns",
    transfers: "Transfers",

    //OrderView
    OrderNo: "Order No",
    order: "Order",
    orderOn: "Ordered on",
    returnOn: "Return on",
    expectedReturn: "Expected Return",
    jobStite: "Field Location",
    orderedOn: "Order No",
    orderedBy: "Ordered by",
    // Tool Details
    toolName: "Asset Name",
    module: "Module",
    section: "Section",
    SubSection: "Sub section",
    refNumber: "Ref No",

    SNo: "S.No",
    Snum: "S.no",
    ScanCode: "Scan Code",
    serialNo: "Serial No",
    barcode: "Barcode",
    model: "Model",
    checkoutBy: "Checkout By",
    trade: "Job Title",
    checkedOutOn: "Checked out on ",
    addToolCategory: "Add asset category",
    editToolCategory: "Edit Asset category",
    addATool: "Add a asset",
    editATool: "Edit Asset",
    addAssetTitle: "Add Asset",
    editAssetTitle: "Edit Asset",
    createAsset: "Create",
    updateAsset: "Update",
    editModeName: "edit",
    assetDetails: "Asset Details",
    lastSeen: "Last Seen",
    homebase: "Homebase",
    fixedAssetNumber: "Fixed Asset Number",
    accessories: "Accessories",
    supplier: "Supplier",
    nfcCode: "NFC Code",
    addMultipletool: "Add multiple assets",
    addMultipleToolsDropCsv: "Drop a CSV file here to upload or",
    addMultipleToolsUploadSuccess: "Tools added successfully",
    inviteMultipleUsersUploadSuccess: "Users invited successfully.",
    addMultipleToolsPartialFailure:
      "Some of the assets have not been added. Kindly check the downloaded csv file.",
    addMultipleToolsSingleFileOnly: "Only single file can be uploaded.",
    addMultipleToolsSelectCsvFile: "Please select CSV File",
    addMultipleToolsUnsupportedType: "Unsupported file type",
    addMultipleToolsOpenUploadedFile: "Open uploaded CSV file",
    csvUploadInstructionFileType: "1) File Format should be CSV.",
    csvUploadInstructionLimit: "2) Maximum file limit is 20 MB.",
    csvUploadInstructionDownloadLinkPrefix: "3) ",
    csvUploadInstructionDownloadLink: "Click here",
    csvUploadInstructionDownloadSuffix: " to Download file.",
    csvUploadInstructionSequence:
      "4) Sequence of columns should be as per file.",
    addMultipleToolsOrganisationRequired: "Please Select Organisation Name",
    addMultipleToolsAssetCategoryRequired: "Please Select Asset Category",
    reorderTagsDropCsv: "Drop a CSV file here to upload or",
    reorderTagsOpenUploadedFile: "Open uploaded CSV file",
    reorderTagsSingleFileOnly: "Only a single file can be uploaded.",
    reorderTagsUnsupportedFile: "Unsupported file type",
    reorderTagsFileRequired: "You must upload a file",
    reorderTagsPartialFailure:
      "Some of the tags cannot be re-ordered. Kindly check the downloaded csv file.",
    reorderTagsPartialFailureNonCsvResponse:
      "Some of the tags cannot be re-ordered, but the failure report was not returned as a CSV file. Please try again or contact support.",
    reorderTagsInstructionPara1Before:
      "This page is intended to help you reorder tags that you have previously ordered. If you wish to order tag numbers that you have not previously ordered, please go back and click ",
    reorderTagsInstructionOrderNew: "Order New",
    reorderTagsInstructionPara2:
      "You may upload a .csv or Excel file, with one row for each tag you would like to reorder. The first column must be titled \u2018orderNumber\u2019.",
    reorderTagsInstructionPara3:
      "Please only submit tag numbers that start with the same prefix. If you have tags of various prefixes to order, please submit them in separate files.",
    reorderTagsInstructionPara4Before:
      "When reordering tags, the tag type will be \u2018Standard\u2019. While the tags will have the prefix specified in the file you upload, this does mean that these tags will have the default logo and name as opposed to your custom tag logo and name. If you wish to order tags with your custom tag, please go back and click ",
    browse: "Browse",
    drill: "Drill",
    noOfTools: "No of Assets",
    submit: "Submit",
    dummyText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //Field of Service
    services: "Services",
    service: "Service",
    tools: "Assets",
    tool: "Asset",
    serviceHistory: "Service History",
    toolsrno: "Asset No.",
    toolssrno: "Assets No.",
    toolSerialNo: "Asset Serial No",
    servicedue: "Service Due",
    scheduleService: "Schedule Service",
    reScheduleService: "Reschedule Service",
    cancelService: "Cancel Service",
    upcomingServiceOnly: "Upcoming Service Only",
    allFutureServices: "All Future Services",
    make: "Make",
    serviceReminder: "Service Reminder",
    cancelationNote: "Cancellation Note",
    nextServiceReminder: "Next Service Reminder",
    apply: "Apply",
    cancelTitle: "Comment for cancellation",
    required: "Required",
    notRequired: "Not Required",
    //Manage Users
    users: "Users",
    invites: "Invites",
    invitedDate: "Invited Date",

    Active: "Active",
    Inactive: "Inactive",
    inviteUser: "Invite User",
    activeUsers: "Activate user",
    accept: "Accept",
    acceptRequest: "Accept Request",
    declineRequest: "Decline Request",
    addIcon: "Add",
    warehouseHeaderButtonString: "Add",
    warehouseAddToolCategoryString: "Add asset category",
    warehouseAddToolString: "Add a asset",
    warehouseAddMultipleToolString: "Add multiple assets",
    decline: "Decline",
    acceptExtention: "Accept Extention",
    declineExtention: "Decline Extention",
    Export: "Export",
    ExportasPDF: "Export as PDF",
    ExportasExcel: "Export as Excel",
    deactivateUsers: "Deactivate user",
    inviteUsers: "Invite Users",
    inviteMultipleUser: "Invite Multiple Users",
    inviteMultipleUsersUserTypeRequired: "Please Select User Type",
    inviteMultipleUsersOrganisationRequired: "Please Select Organisation",
    inviteMultipleUsersPartialFailure:
      "Some of the Users have not been added. Kindly check the downloaded csv file.",
    singleFileOnly: "Only single file can be uploaded.",
    selectCSVFile: "Please select CSV File",
    unsupportedFileType: "Unsupported file type",
    editUser: "Edit User",
    deleteuser: "Delete user",
    userName: "User name",
    Username: "Username",
    userType: "User type",
    organization: "Select Organisation",
    totalActiveUser: "Total Active User",
    totalInactiveUser: "Total Inactive User",
    totalSubOrganization: "Total Sub-Organisation",
    subOrganization: "Select Sub-Organisation",
    userProfile: "User Profile",
    editProfile: "Edit Profile",
    changePassword: "Change Password",
    empId: "Employee ID",
    phoneNo: "Phone No",
    temp_password: "Temp password",
    organisation: "Organisation",
    subOrganisation: "Sub-Organisation",
    actions: "Actions",
    action: "Action",
    actionBy: "Action by",
    manageUsers: "Manage User",
    userAlertDeactivateMsg: "Are you sure you want to deactivate these user ",
    userAlertActivateMsg: "Are you sure you want to activate these user ",
    deleteUserAlertDelete: "Are you sure you want to delete these users ? ",
    userAlertChangeMsg:
      "Are you sure you want to change the status of these user ",
    nouser: "No users Selected",
    selectAtleastoneuser: "Please select at least one user ",
    usersSelected: "Users selected",
    organizationsSelected: "Organisations Selected",
    organizationSelected: "Organisation Selected",
    subOrganizationsSelected: "Suborganisations Selected",
    subOrganizationSelected: "Suborganisation Selected",
    noSubOrganisationsFound: "No Sub-organisations found",
    userSelected: "User selected",
    singleUserAlertDeactivate: "Are you sure you want to deactivate this user ",
    singleUserAlertActivate: "Are you sure you want to activate this user ",
    singleUserAlertDelete: "Are you sure you want to delete this user ?",
    cancelServiceAlert: "Are you sure you want to cancel the service?",
    deleteServiceHistory:
      "Are you sure you want to delete the servicing record?",

    //tool list
    sno: "S. No",
    checkoutDate: "Checkout Date",
    checkoutTime: "Checkout Time",

    //invite user
    firstName: "First Name",
    lastName: "Last Name",
    phoneNumber: "Phone number",
    phoneno: "Phone no.",
    country: "Country",
    SelectCountry: "Select Country",
    selectCountryCode: "Please Select Country Code",

    //userDetails
    email: "Email",
    emailId: "Email ID",
    emailAdd: "Email address",
    orgName: "Organisation Name",
    subOrgName: "Sub-Organisation Name",
    addedOn: "Added on",
    deleteUserAlert: "Are you sure you want to delete these user ",

    //propname
    firstname: "firstName",
    lastname: "lastName",
    employeeId1: "empId",
    tradeProp1: "tradeId",
    mno: "mobile",
    itemName: "Item Name",
    sNo: "S. no",
    org: "organisationName",
    emailProp: "email",

    dateRange: "Date range",
    category: "Category",
    avlQuantityRange: "Avl qty range",

    deleteTool: "Delete Asset",
    Alerts: {
      categoryAdded: "Category added successfully",
      toolAdded: "Asset added successfully",
      profileAdded: "Profile updated successfully",
      profilePicture: "Profile Picture",
      toolDataUpdated: "Asset Data has been updated successfully.",
      toolReported: "Asset report has been succesfully logged",
    },
    //Filter  screen
    wholeMonth: "Whole month",
    clearAll: "Clear All",
    applyFilter: "Apply Filter",
    categoryView: "By Category",
    toolView: "By Asset",
    byCategory: "By Category",
    byAsset: "By Asset",
    byOrder: "By Order",

    OrderView: "By Order",
    ToolView: "By Asset",
    pickupLocation: "Pickup location",
    orderBy: "Order by",
    orderDate: "Order Date",
    orderTime: "Order Time",

    pdfExported: "PDF Successfully Exported.",
    excelExported: "Excel Successfully Exported.",
    managedUserExportInvalidResponse:
      "Export failed. The server did not return a valid file.",
    ok: "Ok",
    edit: "Edit",
    delete: "Delete",
    activate: "Activate",
    deActivate: "Deactivate",
    excel: "Excel",
    PDF: "PDF",
    logoutMsg: "Are you sure, you want to logout ?",
    oops: "Oops...",

    userUpdated: "User Updated Successfully.",
    logoUpdated: "Logo Updated Successfully.",
    themeUpdated: "Theme Updated Successfully.",
    userInvited: "User Invited Successfully.",
    scheduledServiceMsg: "Scheduled service successfully.",
    reScheduledServiceMsg: "Re-Scheduled service successfully.",
    cancelledServiceMsg:
      "Your asset servicing request is cancelled successfully",
    deleteServiceHistoryMsg: "Record deleted successfully",
    validateSuccess: "Validate Successfully",
    exportPDF: "exportPDF",
    exportCSV: "exportCSV",
    //request form
    regNo: "Reservation Number",
    regNoProp: "regNo",

    reserveBy: "Reserved by",
    reservedByProp: "reserved",

    employeeId: "Employee ID",
    employeeIdProp: "employeeId",

    tradeProp: "Job Title",

    pickLocation: "Pickup Location",
    pickLocationProp: "pickUpLocation",

    jobSite: "Field Location",
    jobSiteProp: "Field Location",
    jobSite2: "Field Location",

    reservedProp: "reservedOn",

    pickupOn: "Pickup On",
    pickupProp: "PickupOn",
    effectiveFrom: "Effective From",

    notes: "Notes",
    itemsToBeApproved: "Items to Be Approved",
    notesProp: "notes",
    categoryAddedSuccessfully: "Category Added Successfully.",
    categoryUpdatedSuccessfully: "Category Updated Successfully.",
    editTool: "Edit Asset",
    requestAcceptedMsg: "Request accepted successfully",
    requestDeclinedMsg: "Request declined successfully",
    toolsDeleteAlert: "Are you sure you want to delete these assets ?",
    toolsStatusUpdated: "Assets status updated successfully.",
    toolCategoryDeleted: "Asset Category deleted successfully.",
    toolCategoriesDeleted: "Asset Categories deleted successfully.",
    toolDeleted: "Asset deleted successfully.",
    toolsDeleted: "Assets deleted successfully.",
    historyUpdatedMsg: "Service details updated successfully.",

    // settings
    tradeBack: "Add/Remove - Job Titles",
    jobsiteBack: "Add/Remove - Field Locations",
    pickupLocationBack: "Add/Remove - Pickup Locations",
    logoBack: "Customize - Logo",
    themeBack: "Customize - Theme",
    brandBack: "Add/Remove - Model Types",
    organizationBack: "Add/Remove - Organisation",
    subOrganizationBack: "Add/Remove - SubOrganisation",
    organisationTitle: "Organisation",
    subOrganizationTitle: "SubOrganisation",
    orgFooterName: "Organisations",
    subOrgFooterName: "Sub-Organisations",
    jobsFooterName: "Jobs Titles",
    fieldFooterName: "Field Locations",
    pickFooterName: "Pickup Locations",
    modelFooterName: "Model types",
    tradeNameFormField: "Job Title Name",
    jobsiteNameFormField: "Field Location Name",
    pickupLocationNameFormField: "Pickup Location",
    brandNameFormField: "Model Type Name",
    organizationNameFormField: "Organisation Name",
    subOrganizationNameFormField: "SubOrganisation Name",
    addImage: "Add Image",
    logoUploadHelpText:
      "Please upload a transparent .png with a 4:1 aspect ratio for best results.",
    defaultThemeName: "Blue",
    settingsTabRearrange: "Rearrange",
    settingsTabCustomize: "Customise",
    settingsTabAddRemove: "Add/Remove",
    sectionTitleLogo: "Logo",
    sectionTitleTheme: "Theme",
    comingSoon: "This functionality is coming soon...",
    search: "Search",
    selectAll: "Select All",
    select: "Select",
    successfullyAdded: "Successfully Added",

    // Settings Add/Remove Options
    addRemoveFieldLocation: "Field Location",
    addRemoveJobTitle: "Job Title",
    addRemoveModelType: "Model Type",
    addRemovePickupLocation: "Pickup Location",
    addRemoveOrganization: "Organisation",
    addRemoveSubOrganization: "Sub-Organisation",

    // Settings Rearrange Options
    rearrangeDashboardTiles: "Dashboard Tiles",
    rearrangeBookingTabs: "Booking Tabs",
    settingsUpdatedSuccessfully: "Settings updated successfully",

    // Tag orders
    OrderTags: "Order Tags",
    OrderNew: "Order New",
    ReorderTag: "Reorder Tag",
    tagTabTitle: "Tag Orders",
    tagsHeading: "Tags",
    orderTagsSectionTitle: "Order Tags",
    selectTagType: "Select Tag Type",
    orderPremium: "Order Premium",
    orderStandard: "Order Standard",
    premiumTagTitle: "Premium Tag",
    standardTagTitle: "Standard Tag",
    premiumTagDescription:
      "Customised tag with your company's logo and number sequences.",
    standardTagDescription: "Standard MyAsset logo and number sequence.",
    noCustomisations: "No customisations.",
    editTagButton: "Edit Tag",
    changePlan: "Change Plan",
    OrderDraft: "Order Drafts",
    completeOrder: "Complete Order",
    editOrder: "Edit Order",
    save: "Save",
    saving: "Saving...",
    updateDraft: "Update Draft",
    OrderHistory: "Order History",
    EditTag: "Edit premium tag",
    editTagNewHeading: "Edit Tag",
    customise: "Customise",
    tagLogo: "Tag Logo",
    organisationName: "Organisation Name",
    prefix: "Prefix (2 letters)",
    prefixPlaceholder: "OP",
    sequenceStartsFrom: "Sequence starts from (4 digits)",
    sequenceStartsFromPlaceholder: "0001",
    orgNamePlaceholder: "Organisation name (10 - 16 characters)",
    filesSupportedTag: "Files supported: JPEG, PNG up to 2MB",
    editTagUpdate: "Update",
    viewPlan: "View Plans",
    PremiumTagOrder: "Order Premium tags",
    StandardTagOrder: "Order Standard tags",
    premiumTag: "PREMIUM TAG",
    standardTag: "STANDARD TAG",
    tagMoadlMessage:
      "Looks like your order doesn t meet the minimum order requirement for Premium/customised tags . Please choose one of the following options to proceed.",
    tagleftMessage: "Proceed with current order (Standard Tags + Higher Price)",
    tagRightMessage: "Update order to 1000 tags (Premium Tags + Lower Price)",
    planModalText:
      "Please upgrade to Gold/Platinum account to customise your tags",
    previousSequence: "Continue from previous order sequence",
    customSequence: "Create a custom sequence",
    splitSequence: "Create custom split sequences",
    customSuccessMessage: "successfully updated a custom tag",
    successUpdate: "successfully updated an order",
    successCreateOrder: "successfully created an order",
    confirmDeleteTag: "Are you sure you want to delete this draft?",
    confirmDeleteTags: "Are you sure you want to delete these drafts?",
    tagDeleteSuccess: "Order draft successfully deleted",
    customTags: "Custom Tags",
    customizeTags: "Customize my tag",
    tagType: {
      premium: "Premium",
      standard: "Standard",
    },
    address: {
      edit: "Edit address",
      delete: "Delete address",
      new: "Add New",
      lineOne: "Address line 1",
      lineTwo: "Address line 2 (optional)",
      city: "Town/City",
      postcode: "Post code",
      deleteConfirm: "Are you sure you wish to delete this address?",
      shipping: "Shipping Address",
      selectShipping: "Select a shipping address",
      addShipping: "Add a shipping address",
    },
    price: {
      unit: "Tag Unit Price",
      tagTotal: "Tag Total",
      tax: "Tax",
      shipping: "Shipping",
      total: "Order Total",
      detail: "Price Details",
    },
    priceInformation: "All prices are in NZD and exclude GST",
    orderNew: {
      heading: "Order New",
      back: "Back",
      addMoreFields: "+ Add more fields",
      tagQuantity: "Tag Quantity",
      startSequence: "Start Sequence",
      endSequence: "End Sequence",
      tagQty: "Tag Qty",
      sequencePlaceholder: "OP00000",
      minPremiumQtyText: "1000 tags minimum order for premium tags.",
      learnMore: "Learn More",
      tagPriceExclGst: "Tag Price (excl. GST)",
      totalPriceExclGst: "Total Price (excl. GST)",
      termsDeclaration: "I hereby declare that I have read and agreed to the",
      termsAndConditions: "Terms & Conditions",
      privacyPolicy: "Privacy Policy",
      termsError:
        "**You must acknowledge that you have read and agree to the Terms of Use to continue",
      payPalGenericError:
        "Something went wrong, and your payment was not processed. Please try again.",
      tagsFilled: "tags filled",
      tagsMore: "tags more",
    },
    tagOrder: {
      draftId: "Tag Order Draft ID",
      id: "Tag Order ID",
      dataMsg:
        "Please don’t worry. Your data is safe with us. We assure not to share your personal information with any third party users.",
      protectData: "We protect your data",
      orderNo: "Tag Order No.",
      type: "Tag Type",
      qty: "No. of Tags",
      sequence: "Tag Sequence",
      amount: "Tag Order Amount",
      date: "Tag Order Date & Time",
      shortDate: "Tag order D&T",
      draftDate: "Tag order draft D&T",
      orderBy: "Tag Order By",
      email: "Email",
      phoneNo: "Phone No.",
      lostItems:
        "Please note that we will not be held responsible for any lost items",
      timeline:
        "It will take 10 days to manufacture and 3–5 days to ship your tags.",
      paymentDisclaminer:
        " Please note that we will not be held responsible for any items lost in transit.",
      payPalFinalizeError:
        "An issue occurred while finalizing your order. Please contact support.",
    },
    plan: {
      choose: "Choose a plan",
      current: "Current Plan",
      limitedCustomisation: "Customisation available only on 1000+ tag orders",
      request: "Send Request",
      customizeBeforeOrdering:
        "You must set up your custom tag before ordering premium tags",
      requestMessage:
        "We have received your request to upgade and will get in touch with you shortly",
      requestedPlan: "Requested plan",
    },
    orderSequenceText: {
      unavailableSequence:
        "Customisation of sequence is only available for premium tag order",
    },
    adminPermissionRequired:
      "Administrator permissions are required to change a plan. Please contact an administrator within your organisation.",
    cancelModal: "close",

    // Servicing
    servicing: {
      // Tabs
      serviceChecklists: "Service Checklists",
      checklist: "Checklist",
      scheduling: "Scheduling",
      reports: "Reports",
      servicing: "Servicing",
      servicingDetails: "Servicing Details",
      history: "History",
      download: "Download",
      nextService: "Next Service",
      lastService: "Last Service",
      scheduledServices: "Scheduled Services",
      // Table Headers
      nfcCode: "NFC Code",
      assetCategory: "Asset Category",
      scheduled: "Scheduled",
      status: "Status",
      prevServiceResults: "Previous Service Results",
      details: "Details",
      actions: "Actions",
      title: "Title",
      type: "Type",
      addedBy: "Added By",

      // Status Labels
      dueSoon: "Due Soon",
      statusScheduled: "Scheduled",
      overdue: "Overdue",
      unscheduled: "Unscheduled",
      cancelled: "Cancelled",
      cancelledPermanently: "Cancelled Permanently",
      completed: "Completed",

      // Filter Labels
      scheduling: "Scheduling",
      serviceStatus: "Service status",
      scheduledFor: "Scheduled For",
      resultAndAssetCondition: "Result & Asset Condition",

      // Common Labels
      search: "Search",
      back: "Back",
      filter: "Filter",
      unknown: "Unknown",

      // Action Menu Items
      view: "View",
      edit: "Edit",
      duplicate: "Duplicate",
      viewDetails: "View Details",
      schedule: "Schedule",
      reschedule: "Reschedule",
      service: "Service",
      nonRecurring: "Non-Recurring",
      markComplete: "Mark Complete",
      generateReport: "Generate Report",
      scheduleNow: "Schedule Now",
      prioritySchedule: "Priority Schedule",
      calibrationReport: "Calibration Report",
      orderParts: "Order Parts",
      shutdownSchedule: "Shutdown Schedule",
      assignCategory: "Assign Category",
      setupSchedule: "Setup Schedule",
      autoRescheduling: "Auto Rescheduling",
      // Tooltip Headers
      serviceTitle: "Service Title",
      scheduledFor: "Scheduled For",
      conductedOn: "Conducted On",
      servicer: "Servicer",
      addNew: "Add New",
      reschedulingFrequency: "Rescheduling Frequency",
      serviceReminder: "Service Reminder",
      pleaseSelectServiceSchedule:
        "Please select the service you wish to reschedule",
      pleaseSelectServiceToCancel:
        "Please select the service(s) you wish to cancel",
      cancelServiceConfirmation: "Are you sure you want to cancel the service?",
      editedBy: "Edited By",
      createdBy: "Created By",
      editorSignature: "Editor Signature",

      // Schedule History
      scheduleHistory: "Schedule History",
      noScheduleHistory: "No schedule history available",
      noServiceReportAvailable: "No Service Report available",
      noServiceChecklistAvailable: "No Service template available",
      noServiceScheduleAvailable: "No Service Schedule available",
      loadingServiceSchedule: "Loading Service Schedules...",
      loadingServiceTemplate: "Loading Service Templates...",
      loadingServiceReport: "Loading Service Reports...",
      rescheduled: "Rescheduled",
      previousDate: "Previous Date",
      enabled: "Enabled",
      disabled: "Disabled",
      by: "by",
      action: "Action",

      // New Service Checklist
      newServiceTemplate: {
        newServiceTemplate: "New Service Template",
        noServiceTemplateData:
          "No service template data found. Please navigate from the service checklists page.",
        serviceTemplateUpdatedAndPublishedSuccessfully:
          "Service template updated and published successfully",
        serviceTemplateUpdatedAndSavedAsDraftSuccessfully:
          "Service template updated and saved as draft ",
        serviceTemplatePublishedSuccessfully:
          "Service template published successfully",
        serviceTemplateSavedAsDraftSuccessfully:
          "Service template saved as draft successfully",
        failedToPublishServiceTemplate: "Failed to publish service template",
        failedToSaveServiceTemplateAsDraft:
          "Failed to save service template as draft",
        failedToUpdateServiceTemplate: "Failed to update service template",
        failedToDeleteServiceTemplate: "Failed to delete service template",
        failedToDuplicateServiceTemplate:
          "Failed to duplicate service template",
        templateDataNotFound: "Template data not found",
        templateIdNotFound: "Template ID not found",
        serviceTemplateDeletedSuccessfully:
          "Service template deleted successfully",
        serviceTemplateDuplicatedSuccessfully:
          "Service template duplicated successfully",
        generalDetails: "General Details",
        details: "Details",
        editingGeneralDetails: "Editing General Details",
        checklistQuestions: "Checklist Questions",
        editingQuestion: "Editing Question",
        editingChecklist: "Editing Checklist",
        yesNoNotApplicable: "Yes, No, Not Applicable",
        passFailNotApplicable: "Pass, Fail, Not Applicable",
        ReviewAndSave: "Review and Save",
        title: "Title",
        serviceType: "Service Type",
        status: "Status",
        serviceReminder: "Service Reminder",
        serviceResult: "Service Result",
        result: "Result",
        outOfOrder: "Out of Order",
        operableButRequiresAttention: "Operable but Requires Attention",
        assetCategory: "Asset Category",
        assetCondition: "Asset Condition",
        photos: "Photos",
        assets: "Assets",
        question: "Question",
        answerType: "Answer Type",
        assetConditionRequired: "Asset Condition Required",
        assetConditionRequiredForFailedCheck:
          "Asset condition required for failed question/check.",
        assetConditionRequiredTooltip:
          "Specify whether the asset is operable or not if it fails this question/check",
        preServiceInstructions: "Pre-Service Instructions",
        preService: "Pre-Service",
        failedServiceInstructionsOperable:
          "Failed Service Instructions - Operable",
        failedServiceInstructionsOutOfOrder:
          "Failed Service Instructions - Out of order",
        failedServiceInstructions: "Failed Service Instructions - ",
        failedService: "Failed Service",
        instructions: "Instructions",
        outOfOrder: "Out of order",
        operable: "Operable",
        next: "Next",
        finalNotesAndComments: "Final Notes & Comments",
        back: "Back",
        cancel: "Cancel",
        revert: "Revert",
        deleteQuestion: "Delete Question",
        saveChanges: "Save Changes",
        rearrange: "Rearrange",
        reviewAndSave: "Review & Save",
        addQuestion: "Add Question",
        nextQuestion: "Next Question",
        delete: "Delete",
        deletedQuestions: "Deleted Questions",
        questions: "Question(s)",
        otherActions: "Other Actions",
        textInputRequired: "TextInput Required",
        textInput: "Text Input",
        checklistQuestionsRequired:
          "Please add at least one checklist question",
        serviceTypeRequired: "Service type is required",
        assetCategoryRequired: "Asset category is required",
        titleRequired: "Title is required",
        addPhotos: "Add Photos",
        addNotes: "Add Notes",
        selectServiceType: "Select Service Type",
        selectAssetCategory: "Select Asset Category",
        selectAssets: "Select Assets",
        failedServiceOperableTooltip:
          "Post service instructions for the servicer if the service has failed and the asset is operable.",
        failedServiceOutOfOrderTooltip:
          "Post service instructions for the servicer if the service has failed and the asset is out of order.",
        // Review Interface
        preServiceInstructions: "Pre-Service Instructions",
        checklist: "Checklist",
        saveAsDraft: "Save as Draft",
        saveAndPublish: "Save & Publish",
        publish: "Publish",
        saveAndRepublish: "Save & Republish",
        serviceTitle: "Service Title",
        serviceTemplates: "Service Templates",
        yes: "Yes",
        no: "No",
        na: "N/A",
        pass: "Pass",
        fail: "Fail",
        replacedAs: "Replaced as",
        // Validation error messages
        errors: {
          titleRequired: "Title is required",
          serviceTypeRequired: "Service type is required",
          assetCategoryRequired: "Asset category is required",
          assetsRequired: "Assets are required",
        },
      },
      checklistSavedAndPublishedSuccessfully:
        "Checklist saved and published successfully",
      checklistSavedSuccessfully: "Checklist saved successfully",
      checklistPublishedSuccessfully: "Checklist published successfully",
      deleteSelectedQuestionsMessage:
        "Are you sure you want to delete the selected question(s)?",
      deleteServiceTemplateMessage:
        "Are you sure you want to delete this checklist ?",
      confirmCancelService: "Are you sure you want to cancel this service?",
      confirmCancelMultipleServices:
        "Are you sure you want to cancel these services?",
      serviceReport: {
        serviceReport: "Service Report",
      },
      noServiceHistoryAvailable: "No service checklist history available !",
      noServiceHistoryFound:
        "No service checklist history found for your Search !",
      pleaseEnterQuestionForChecklist: "Please enter a question for checklist",
      pleaseEnterQuestionForChecklists:
        "Please enter a question for the checklists",
    },
    helpCenter: {
      title: "How can we help?",
      descriptionLine1:
        "Find instructional videos, manuals, and resources to answer your MyAsset questions.",
      descriptionLine2:
        "If you require immediate support, please get in touch through",
      contact: "Contact",
      searchPlaceholder: "Search MyAsset Help Centre",
      faq: "Frequently Asked Questions",
      noSearchResultsFor: "No search results for",
      searchResultsFor: "search results for",
      noResultsPrompt: "Haven't found what you're looking for?",
      contactUs: "Contact Us",
      back: "Back",
      searchResults: "Search Results",
      accountManagement: "Account Management",
      technology: "Technology",
      websiteAndMobileApp: "Website & Mobile App",
      userManualsAndVideos: "User Manuals & Videos",
    },
    contact: {
      title: "Contact Us",
      description:
        "Have any questions, comments, or concerns? Complete the form below and our team will be in touch with you as soon as possible.",
      firstName: "First Name",
      firstNamePlaceholder: "Firstname",
      lastName: "Last Name",
      lastNamePlaceholder: "Lastname",
      email: "Email",
      emailPlaceholder: "email@email.com",
      phoneNo: "Phone No.",
      yourCompany: "Your Company",
      yourIndustry: "Your Industry",
      queryType: "Query Type",
      message: "Message",
      enterPlaceholder: "Enter",
      selectPlaceholder: "Select...",
      submitting: "Submitting...",
      thankYou: "Thank you!",
      enquirySent: "Your enquiry has been successfully sent.",
      returnToDashboard: "Return to Dashboard",
      firstNameRequired: "Please enter your first name",
      lastNameRequired: "Please enter your last name",
      emailRequired: "Please enter your email",
      emailInvalid: "Please enter a valid email",
      phoneNoRequired: "Please enter your phone number",
      queryTypeRequired: "Please select a query type",
      messageRequired: "Please enter your message",
      submitError: "Failed to send your enquiry. Please try again.",
    },
    agreement: {
      continue: "Continue",
      submit: "Submit",
      back: "Back",
      submitting: "Submitting...",
      updated: "Updated",
      version: "Version",
      termsAndConditionsCheckboxLabel: "I accept the Terms of Use",
      privacyPolicyCheckboxLabel: "I accept the Privacy Policy",
      endUserAggreementCheckboxLabel: "I accept the End User License Agreement",
    },
  },
});
export default Strings;
